// externals

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealHistory, StateTree } from '@makemydeal/dr-dash-types';
import * as dealEffectiveSelectors from '@makemydeal/dr-dash-store/selectors/dealEffectiveSelectors';

// consts
import * as constants from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const SellingPrice = ({ deal, hasDelta = false }: { deal?: DealHistory; hasDelta?: boolean }) => {
    const offerPrice = useTrackedSelector((state: StateTree) => dealEffectiveSelectors.getEffectiveSellingPrice(state, deal), {
        component: 'SellingPrice',
        field: 'effectiveSellingPrice'
    });
    const sellingPrice = formatDollarsAndCents(offerPrice);
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            label={constants.SELLING_PRICE}
            value={sellingPrice}
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default SellingPrice;
